import { define } from "omi/src/define"
const classTagMap = new Map()
// const tagSet = new Set()
let index = 0
let tagPrefix = "oi-part"
export default function (componentClass, autoDefine = true) {
    if (classTagMap.has(componentClass)) {
        return classTagMap.get(componentClass)
    }

    let tag = `${tagPrefix}-${index++}`
    classTagMap.set(componentClass, tag)
    if (autoDefine) define(tag, componentClass)
    return tag
}